import { render, staticRenderFns } from "./EventPageNav.vue?vue&type=template&id=0ed8d0e8&scoped=true"
import script from "./EventPageNav.vue?vue&type=script&lang=js"
export * from "./EventPageNav.vue?vue&type=script&lang=js"
import style0 from "./EventPageNav.vue?vue&type=style&index=0&id=0ed8d0e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8d0e8",
  null
  
)

export default component.exports